import { FondoOnere } from '../../../models/fondo-onere';

export class FondoOnereAdapter {

  fondoOnere: FondoOnere = new FondoOnere();

  constructor(fondoOnere: FondoOnere) {
    this.fondoOnere.id = fondoOnere.id;
    this.fondoOnere.tipoFase = fondoOnere.tipoFase ? JSON.parse(JSON.stringify(fondoOnere.tipoFase)) : null;
    this.fondoOnere.anno = fondoOnere.anno;
    this.fondoOnere.mese = fondoOnere.mese;
    if (fondoOnere.importo) {
      this.fondoOnere.importo = fondoOnere.importo.toString().trim().replace('.', ',');
    }
    this.fondoOnere.legaleIncaricato = fondoOnere.legaleIncaricato ? JSON.parse(JSON.stringify(fondoOnere.legaleIncaricato)) : null;
    this.fondoOnere.nota = fondoOnere.nota;
  }
}
